/* Bella Bazzar | Recomendaciones nativas de Shopify para "Relacionados", pedidas cuando la sección se acerca a pantalla. */
if (!customElements.get('bb-recos')) {
  customElements.define(
    'bb-recos',
    class extends HTMLElement {
      connectedCallback() {
        if (this.hasAttribute('data-ready') || !this.dataset.url) return;
        const load = () => {
          fetch(this.dataset.url)
            .then((response) => (response.ok ? response.text() : ''))
            .then((text) => {
              if (!text) return;
              const html = new DOMParser().parseFromString(text, 'text/html');
              const fresh = html.querySelector('bb-recos');
              if (fresh && fresh.querySelector('.bb-rel__list li')) this.innerHTML = fresh.innerHTML;
            })
            .catch(() => {});
        };
        if (!('IntersectionObserver' in window)) return load();
        const io = new IntersectionObserver(
          (entries) => {
            if (!entries[0].isIntersecting) return;
            io.disconnect();
            load();
          },
          { rootMargin: '0px 0px 600px 0px' }
        );
        io.observe(this);
      }
    }
  );
}

/* Bella Bazzar | Comportamiento de la página de producto.
   1. Botones "Pedir ahora" (barra fija, CTA final y enlaces de las landings) abren el formulario COD de Releasit
      o, si la app no cargó, llevan al botón de compra del tema.
   2. Barra fija en móvil: aparece cuando el botón principal sale de pantalla y se oculta en el CTA final
      o si Releasit muestra su propio botón flotante. */
(() => {
  const infoRoot = document.querySelector('product-info.product__info-container');
  if (!infoRoot) return;

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const mainCodButton = () =>
    [...infoRoot.querySelectorAll('._rsi-buy-now-button')].find(
      (el) => !el.closest('#_rsi-buy-now-button-floating') && el.offsetParent !== null
    );

  const buyArea = () => infoRoot.querySelector('product-form') || infoRoot.querySelector('[id^="price-"]');

  const goToBuy = (openForm) => {
    const cod = mainCodButton();
    if (openForm && cod) {
      cod.click();
      return;
    }
    const target = cod || infoRoot.querySelector('.product-form__submit') || buyArea();
    if (!target) return;
    target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
    if (typeof target.focus === 'function') target.focus({ preventScroll: true });
  };

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-bb-buy]');
    if (trigger) {
      event.preventDefault();
      goToBuy(true);
      return;
    }
    const anchor = event.target.closest('a[href^="#price-"], a[href="#comprar"], a[href="#bb-buy"]');
    if (anchor) {
      event.preventDefault();
      goToBuy(false);
    }
  });

  const sticky = document.querySelector('[data-bb-sticky]');
  const area = buyArea();
  if (!sticky || !area || !('IntersectionObserver' in window)) return;

  const finalCta = document.getElementById('bb-final-cta');
  const floating = () => {
    const el = document.getElementById('_rsi-buy-now-button-floating');
    return el && getComputedStyle(el).display !== 'none' && el.offsetHeight > 0;
  };

  let pastBuyArea = false;
  let finalVisible = false;

  const render = () => {
    const show = pastBuyArea && !finalVisible && !floating();
    sticky.hidden = false;
    sticky.dataset.visible = show ? 'true' : 'false';
    sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
    sticky.querySelectorAll('a, button').forEach((el) => (el.tabIndex = show ? 0 : -1));
    document.body.classList.toggle('bb-has-sticky', show);
  };

  new IntersectionObserver(([entry]) => {
    pastBuyArea = !entry.isIntersecting && entry.boundingClientRect.top < 0;
    render();
  }).observe(area);

  if (finalCta) {
    new IntersectionObserver(([entry]) => {
      finalVisible = entry.isIntersecting;
      render();
    }).observe(finalCta);
  }

  render();
})();
